module.exports = __webpack_public_path__ + "src/img/system-notice.acbf685f.svg";